export function Collection() {
	this.loaded = false
	this.items = {}
}
